export function setupAccordions(className, onActivate = () => {}) {
    const accordionWraps = $(className);
    if (accordionWraps.length) {
        accordionWraps.each(function () {

            const headers = $(this).find('> h3');
            let active = false;
            headers.each(function (idx) {
                if ($(this).hasClass('default-expanded')) {
                    active = idx;
                }
            });

            $(this).accordion({
                collapsible: true,
                heightStyle: 'content',
                active: active,
                activate: onActivate
            });
        });
    }
}